/**
 * Sovg'a FX — docs/SPEC.md §Sovg'a FX.
 *
 * To'liq ekran overlay, `pointer-events:none`, **2400 ms**. Emoji 104px,
 * ostida ikkita halqa, nomi gradient matn.
 *
 * `prefers-reduced-motion` da halqalar o'chadi (motion.css cheksiz
 * animatsiyalarni to'xtatadi), emoji va matn qoladi — hodisa baribir
 * ko'rinishi kerak.
 */

import { useEffect } from 'react';

import { uz } from '../i18n/uz';
import './sheet.css';

/** SPEC: davomiyligi 2400 ms. */
export const FX_DURATION_MS = 2_400;

export interface GiftFxPayload {
  icon: string;
  name: string;
  combo: number;
}

export function GiftFx({ gift, onDone }: { gift: GiftFxPayload; onDone: () => void }) {
  useEffect(() => {
    const timer = setTimeout(onDone, FX_DURATION_MS);
    return () => clearTimeout(timer);
  }, [gift, onDone]);

  return (
    <div className="fx" aria-live="polite">
      <div className="fx__stage">
        <div className="fx__ring" />
        <div className="fx__ring fx__ring--delayed" />
        <div className="fx__icon">{gift.icon}</div>
      </div>
      <div className="fx__name">{gift.name}</div>
      {gift.combo > 1 && <div className="fx__combo tnum">{`×${gift.combo}`}</div>}
      <span className="sr-only">{uz.gift.sent}</span>
    </div>
  );
}
